import React from 'react';
import QuizSubjectTopics from '../../topics/QuizSubjectTopics';

function QuizEnglishTopics() {
  return (
   <>
   
   <QuizSubjectTopics name="quiz" link="quiz/english" type="quiz" subject="english" topic="atoz" subjectName="english" />
   
   </>
  );
}

export default QuizEnglishTopics;